import React from "react";

import * as typography from "@client/shared/typography";

import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.ManagerSettings) => (
    <ManagerLayout title="Settings" narrow currentClientManagerId={null}>
        <form method="POST" action="" className="flex flex-col space-y-[15px]!">
            <ClientNavigation>
                <typography.Header>Settings</typography.Header>
            </ClientNavigation>
            <forms.CSRFToken />

            <typography.Title>Check-ins</typography.Title>
            <typography.P>
                Enable or disable questions for client check-ins. To schedule a check-in
                for a client, visit their planner.
            </typography.P>

            <forms.ManagementForm formSet={props.client_check_in_question_form_set} />
            {props.client_check_in_question_form_set.forms.map((formSetForm) => (
                <forms.Fields key={formSetForm.prefix} form={formSetForm} />
            ))}
            <forms.Fields
                form={props.settings_form}
                fields={["check_in_notes_label"]}
            />
            <typography.Title>Measurements</typography.Title>
            <typography.P>
                Enable or disable measurements your clients can self-report every day.
            </typography.P>
            <forms.Fields
                form={props.settings_form}
                exclude={[
                    "check_in_notification",
                    "check_in_notes_label",
                    "primary_metric",
                    "secondary_metric",
                    "tertiary_metric",
                    "has_hidden_macros",
                ]}
            />
            <typography.Title>Dashboard</typography.Title>
            <typography.P>
                All the measurements you selected above are visible in your reports.
            </typography.P>
            <typography.P>
                The three selected below will also be shown on your dashboard and track
                weekly changes.
            </typography.P>
            <div
                className="
                    m-[-5px] flex flex-wrap items-end
                    *:m-[5px]
                "
            >
                <forms.Fields
                    form={props.settings_form}
                    fields={["primary_metric", "secondary_metric", "tertiary_metric"]}
                />
            </div>
            <typography.Title>Notifications</typography.Title>
            <typography.P>Choose when you would like to be emailed.</typography.P>
            <forms.Fields
                form={props.settings_form}
                fields={["check_in_notification"]}
            />
            <typography.Title>Beta features</typography.Title>
            <typography.P>
                These are features we’re testing and still tweaking. Feel free to use
                them but they may change substantially or disappear entirely.
            </typography.P>
            <forms.Fields form={props.settings_form} fields={["has_hidden_macros"]} />
            <typography.Button submit>Save</typography.Button>
        </form>
    </ManagerLayout>
);
